<template>
  <div class="posting-list">
    <BaseContainer
      :active-spacer="true"
      :permission-list="['admin', 'owner', 'buyer']"
    >
      <template v-slot:header-title>
        {{ getTextMenu('postings', 'Lançamentos') }}
      </template>
      <template v-slot:header-title-description>
        Lista de lançamentos contábeis
      </template>

      <div class="posting-list__header__actions">
        <div class="mr-2">
          <BaseDatePicker
            name-placeholder="Data Inicial"
            :date-value="filter.start_date"
            :max="filter.end_date"
            :max-width="118"
            locale="pt-br"
            time-zone="UTC"
            @on-input-date-picker="(value) => { updateFilter(value, 'start_date') }"
          />
        </div>
        <div class="mr-2">
          <BaseDatePicker
            name-placeholder="Data Final"
            :date-value="filter.end_date"
            :max="null"
            :max-width="118"
            locale="pt-br"
            time-zone="UTC"
            @on-input-date-picker="(value) => { updateFilter(value, 'end_date') }"
          />
        </div>
        <div class="mr-2">
          <v-select
            v-model="filter.wallet"
            :items="getWallets()"
            label="Carteira"
            clearable
            style="max-width: 200px;"
            @change="getChartOfAccounts"
          />
        </div>
        <div class="mr-2">
          <v-autocomplete
            v-model="filter.account"
            :items="dataChartOfAccounts"
            item-value="account"
            item-text="name"
            label="Conta"
            clearable
            style="max-width: 250px;"
          />
        </div>
        <v-tooltip
          bottom
          :disabled="filter.account && filter.wallet ? true : false"
        >
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <BaseButton
                type="text"
                color="gray74"
                context-button="program"
                :is-disabled="!filter.account || !filter.wallet"
                @click="getPostings(true)"
              >
                FILTRAR
              </BaseButton>
            </span>
          </template>
          Selecione a carteira e conta.
        </v-tooltip>
        <v-spacer />
        <div class="mr-2">
          <download-csv
            style="cursor: pointer; letter-spacing: unset;"
            title="Exportar CSV"
            class="v-btn v-size--default app-font-semibold"
            :data="dataPostingList"
            :name="getFileName()"
          >
            DOWNLOAD
            <v-icon>file_download</v-icon>
          </download-csv>
        </div>
      </div>
      <BaseDataTable
        :headers="tablePostingHeaders"
        :hide-headers="true"
        :items="dataPostingList"
        item-key="transaction_id"
        background-color="var(--v-contrast-base)"
        classes="elevation-2 mt-6"
        :total-items="postingListTotalElements"
        :options="pagination"
        @update-pagination="updatePagination"
      >
        <template v-slot:inject-header="{headers}">
          <tr>
            <th
              v-for="(header, index) in headers.props.headers"
              :key="index"
              style="white-space: nowrap;"
            >
              {{ translateRoleType(header.text) }}
            </th>
          </tr>
        </template>

        <template v-slot:inject-items="scopedItems">
          <tr
            v-for="props in scopedItems"
            :key="props.index"
          >
            <template
              v-for="header, index in tablePostingHeaders"
            >
              <td
                :key="index"
                class="text-left"
              >
                <div v-if="header.hidden === 'true' && hideAllData">
                  {{ hideData(props.item[header.value], header.hidden) }}
                </div>
                <div v-else-if="header.value === 'status.name'">
                  <v-chip
                    class="posting-list__item--status font-weight-medium"
                    :color="convertStatus(props.item['status.category'])"
                  >
                    {{ props.item[header.value] || '-' }}
                  </v-chip>
                </div>
                <div v-else-if="header.value === 'type.title'">
                  <BaseTextTooltip
                    :text-item="formatFields(header.value, props.item, header.input_type) || '-'"
                    width-item="65"
                  />
                </div>
                <div v-else-if="header.value === 'to.name' || header.value === 'from.name'">
                  <BaseTextTooltip
                    :text-item="formatFields(header.value, props.item, header.input_type) || '-'"
                    width-item="100"
                    min-width-item="100%"
                  />
                </div>
                <div v-else>
                  {{ formatFields(header.value, props.item, header.input_type) || '-' }}
                </div>
              </td>
            </template>
          </tr>
        </template>
      </BaseDataTable>
    </BaseContainer>
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations, mapGetters} from 'vuex'
import loader from '../../global/loader'
import BaseDataTable from '../BaseDataTable.vue'
import BaseDatePicker from '../BaseDatePicker.vue'
import ProgramRoles from "../../mixins/ProgramRoles";

export default {
  components: {BaseDataTable, BaseDatePicker},
  mixins: [ProgramRoles],
  data: () => ({
    disabledFirstLoadUpdateDataTable: true,
    filter: {
      start_date: '',
      wallet: '',
      account: '',
      end_date: ''
    },
    pagination: {
      page: 1,
      itemsPerPage: 25
    },
    tablePostingHeaders: [],
    fieldsPostingColumn: [],
  }),
  computed: {
    ...mapState({
      postingList: (state) => {
        return state.accounts.programPostings
      },
      programInitiator: (state) => state.platformProgram.programInitiator,
      chartOfAccounts: (state) => state.accounts.chartOfAccounts
    }),
    dataPostingList() {
      return this.postingList.content ? this.postingList.content : []
    },
    postingListTotalElements() {
      return this.postingList.page ? this.postingList.page.total_elements : 0
    },
    postingListLastEvaluatedId() {
      return this.postingList.page && this.postingList.page.last_evaluated_map && JSON.stringify(this.postingList.page.last_evaluated_map) !== '{}' ? this.postingList.page.last_evaluated_map : null
    },
    dataChartOfAccounts(){
      return this.chartOfAccounts.accounts && this.chartOfAccounts.accounts[0] ? this.chartOfAccounts.accounts : []
    }
  },
  methods: {
    ...mapActions(['apiGetProgramPostings', 'apiGetChartOfAccounts', 'apiGetProgramInfo','apiGetWallets']),
    ...mapActions('programMovements',['apiGetSchemas']),
    ...mapGetters(['getWallets']),
    ...mapMutations(["setDisableNavigation", "setFilter"]),
    updatePagination(pagination) {
      const reducePaginationAttributes = {
        page: pagination.page,
        itemsPerPage: pagination.itemsPerPage,
      }
      this.pagination = reducePaginationAttributes
      this.setPaginationToFilter()
      if (this.disabledFirstLoadUpdateDataTable) {
        this.disabledFirstLoadUpdateDataTable = false
        return
      }
      this.getPostings()
    },
    setPaginationToFilter() {
      this.filter.page = this.pagination.page;
      this.filter.size = this.pagination.itemsPerPage;
    },
    parseHeadersPostingTable(){
      let tablePostingColumn = this.fieldsPostingColumn.data.fields.sort((a, b) => a.sequence - b.sequence) || []
      let fields = tablePostingColumn.map(header => {
        return {
          hidden: header.hidden,
          text: header.name,
          value: header.key,
          class: header.key,
          'input_type': header['input_type'],
          sortable: true
        }
      })
      this.tablePostingHeaders = [...fields]
    },
    convertStatus(value) {
      const status = {
        'in-progress': "progress",
        done: "running",
        created: "ok"
      }
      return status[value]
    },
    async getPostings(clearFilter = false) {
      loader.startProgressLoadPage()
      if(clearFilter) {
        this.disabledFirstLoadUpdateDataTable = true
        delete this.filter.last_evaluated_values
        this.$set(this.filter, 'page', 1)

        this.pagination = {
          ...this.pagination,
          page: 1
        }
      } else {
        if(this.postingListLastEvaluatedId){
          this.filter.last_evaluated_values = this.postingListLastEvaluatedId
        }
      }
      await this.apiGetProgramPostings(this.filter)
      loader.stopProgressLoadPage()
    },
    getFileName() {
      return "postings_" + new Date().getTime() + ".csv";
    },
    toLocalDate(date) {
      return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    },
    updateFilter(value, attribute) {
      this.filter[attribute] = value
    },
    async getChartOfAccounts(){
      if(this.filter.wallet){
        await this.apiGetChartOfAccounts(this.filter.wallet)
        if(this.dataChartOfAccounts.length){
          this.filter.account = this.dataChartOfAccounts[0].account
        }
      } else {
        this.filter.account = ''
      }
    }
  },
  async created() {
    this.filter = {
      ...this.filter,
      'start_date': this.toLocalDate(new Date()).toISOString().substr(0, 10),
      'end_date': this.toLocalDate(new Date()).toISOString().substr(0, 10)
    }
    this.setPaginationToFilter()
    this.fieldsPostingColumn = await this.apiGetSchemas({ scope: 'posting-table' })
    this.parseHeadersPostingTable()
  },
  async mounted() {
    if(!this.programInitiator){
      await this.apiGetProgramInfo()
    }
    this.setFilter({initiator: this.programInitiator})
    loader.startProgressLoadPage()

    await this.apiGetWallets()
    if (this.filter.wallet == '') {
      this.filter.wallet = this.getWallets()[0]
    }
    await this.getChartOfAccounts()
    this.getPostings(true)
    loader.stopProgressLoadPage()
  }
}
</script>

<style lang="scss">
.posting-list__header__actions {
  display: flex;
  align-items: center;
}

.posting-list .base-data-table {
  .account {
    width: 40px;
  }

  .amount {
    width: 50px;
  }

  .date {
    width: 50px;
  }

  .description {
    width: 110px;
  }

}

.posting-list {
  .base-data-table th {
    font-weight: 600 !important;
  }

  .v-data-footer {
    border-top: thin solid rgba(0, 0, 0, 0.12) !important;
  }

  .posting-list__item--status {
    color: rgba(0, 0, 0, 0.54) !important;
    display: inline-block;
    font-size: 10px !important;
    height: 24px !important;
    min-width: 120px;
    margin: 4px !important;
    text-align: center;
  }
}
</style>
